import {register} from '../vendor/theme-scripts/theme-sections';
import ticker from '../features/ticker';

register('announcement', ticker);
